import React from "react";
import {
    Box,
    Typography,
    useMediaQuery,
    useTheme,
    Divider
} from "@mui/material";
import BadgeImage from "../../../components/badges_image/badgesImage";

const BadgesDetailsCards = ({ data, index }) => {
    const theme = useTheme();
    const isMobile = useMediaQuery(theme.breakpoints.down("sm"));

    return (
        <Box
            sx={{
                backgroundColor: "rgba(246, 96, 95, 0.05)",
                borderRadius: "10px",
                border: "1px solid rgba(204, 204, 204, 1)",
                padding: 2,
                width: "100%",
                display: "flex",
                flexDirection: "row",
                alignItems: "center",
                flexWrap: "nowrap",
                overflow: "hidden"
            }}
            key={index}
        >
            <Box
                sx={{
                    flex: "0 0 auto",
                    display: "flex",
                    flexDirection: "column",
                    alignItems: "center",
                    textAlign: "center",
                    minWidth: isMobile ? 80 : 120,
                    borderRight: "1px solid #e0e0e0",
                    pr: 1
                }}
            >
                <BadgeImage
                    badgeName={(data.badgeName || "default").toLowerCase()}
                    altText={data.badgeName || "Default Badge"}
                    width={isMobile ? 50 : 80}
                    height={isMobile ? 50 : 80}
                />
                <Box>
                    <Typography
                        color="text.secondary"
                        sx={{ fontSize: isMobile ? "10px" : "14px" }}
                    >
                        Level
                    </Typography>
                    <Typography
                        sx={{
                            fontSize: isMobile ? "12px" : "16px",
                            whiteSpace: "normal",
                            wordBreak: "break-word"
                        }}
                    >
                        {data.badgeName}
                    </Typography>
                </Box>
            </Box>
            <Box
                sx={{
                    flex: "1 1 auto",
                    display: "flex",
                    flexDirection: "column",
                    gap: 1,
                    minWidth: 0,
                    pl: 3
                }}
            >
                <Box>
                    <Typography
                        color="text.secondary"
                        sx={{ fontSize: isMobile ? "10px" : "14px" }}
                    >
                        Range
                    </Typography>
                    <Typography
                        sx={{
                            fontSize: isMobile ? "12px" : "16px",
                            whiteSpace: "normal", // allow wrapping
                            wordBreak: "break-word"
                        }}
                    >
                        {data.range} Points
                    </Typography>
                </Box>

                <Box>
                    <Typography
                        color="text.secondary"
                        sx={{ fontSize: isMobile ? "10px" : "14px" }}
                    >
                        Requirements
                    </Typography>
                    <Typography
                        sx={{
                            fontSize: isMobile ? "12px" : "14px",
                            whiteSpace: "normal", // allow wrapping
                            wordBreak: "break-word"
                        }}
                    >
                        {data.requirements}
                    </Typography>
                </Box>
            </Box>
        </Box>
    );
};

export default BadgesDetailsCards;
